import { atom } from 'jotai';
import { z } from 'zod';

import type { ZCorrectionCartLineItem } from '@getjust/gateway';

export type CorrectionAtom = z.infer<typeof ZCorrectionCartLineItem>;

export const correctionsAtom = atom<CorrectionAtom[] | null>(null);
